import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SyncOutlinedIcon from '@material-ui/icons/SyncOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useMsal } from "@azure/msal-react";

import { errorToastAction, infoToastAction, successToastAction } from 'utils';
import { isSuccessful, processError } from 'Common/Utils/apiHelpers';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';
import axios from 'http.service';

const ToolsMenu = ({ anchorEl, isMenuOpen, handleMenuClose }) => {
    const menuId = 'primary-search-account-menu';
    const globalDispatch = useDispatch();
    const { instance } = useMsal();


    const handleSyncClick = useCallback(() => {
        syncAppointments(globalDispatch);
        handleMenuClose();
    }, [globalDispatch, handleMenuClose]);

    const handleEmailClick = useCallback(() => {
        sendEmails(globalDispatch);
        handleMenuClose();
    }, [globalDispatch, handleMenuClose]);

    const handleAppointeesClick = () => window.location.href = process.env.REACT_APP_APPOINTEES_URL;

    const handleLogoutClick = () => instance.logoutRedirect();//window.location.href = process.env.REACT_APP_LOGOUT_URL;

    return (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleEmailClick}>
                <ListItemIcon>
                    <EmailOutlinedIcon />
                </ListItemIcon>
                Manually Send Scheduled Emails
            </MenuItem>
            <MenuItem onClick={handleSyncClick}>
                <ListItemIcon>
                    <SyncOutlinedIcon />
                </ListItemIcon>
                Sync Appointments
            </MenuItem>
            <MenuItem onClick={handleAppointeesClick}>
                <ListItemIcon>
                    <ArrowBackIcon />
                </ListItemIcon>
                Appointees Portal
            </MenuItem>

            <MenuItem onClick={handleLogoutClick}>
                <ListItemIcon>
                    <ExitToAppIcon />
                </ListItemIcon>
                Sign Out
            </MenuItem>
        </Menu>
    );
};
async function sendEmails(globalDispatch) {
    const errorCallback = errorMessage => {
        globalDispatch(errorToastAction('Unable to send emails. ' + errorMessage));
    };

    try {
        globalDispatch(infoToastAction('Sending emails...'));

        const { status, data } = await axios.post('/api/v2/contracts/teams/sendScheduledEmails', {}); //replace this with a real endpoint
        if (isSuccessful(status)) {
            globalDispatch(successToastAction('Successfully sent emails.'));
            return;
        }

        const errorMessage = apiErrorMsg(status, data);
        errorCallback(errorMessage);
    } catch (error) {
        processError(error, errorCallback)
    }
}

async function syncAppointments(globalDispatch) {
    const errorCallback = errorMessage => {
        globalDispatch(errorToastAction('Unable to sync appointments. ' + errorMessage));
    };

    try {
        globalDispatch(infoToastAction('Synchronising appointments...'));

        const { status, data } = await axios.post('/api/v2/contracts/teams/sync', {});
        if (isSuccessful(status)) {
            globalDispatch(successToastAction('Successfully synchronised appointments.'));
            return;
        }

        const errorMessage = apiErrorMsg(status, data);
        errorCallback(errorMessage);
    } catch (error) {
        processError(error, errorCallback);
    }
}

ToolsMenu.propTypes = {
    anchorEl: PropTypes.instanceOf(Element),
    isMenuOpen: PropTypes.bool,
    handleMenuClose: PropTypes.func.isRequired,
};

export default React.memo(ToolsMenu);
